var _defs, _mask, _mask2, _g, _mask3, _g2, _mask4, _g3, _mask5, _g4, _mask6, _g5, _mask7, _g6, _mask8, _g7, _mask9, _g8, _mask10, _g9;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNoPage(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 438,
    height: 268,
    viewBox: "0 0 438 268",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "path_0",
    transform: "translate(0 0.4150943396226416) rotate(0 133.1803016148405 102.5283018867925)",
    d: "M0,205.06L266.36,205.06L266.36,0L0,0L0,205.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path_1",
    transform: "translate(0.6905942251138893 0.5445170020414031) rotate(0 16.783252552026415 12.658987856517955)",
    d: "M0,25.32L33.57,25.32L33.57,0L0,0L0,25.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path_2",
    transform: "translate(0.6563443618542866 0.5980318141665993) rotate(0 43.0590489441889 33.82281476589101)",
    d: "M0,67.65L86.12,67.65L86.12,0L0,0L0,67.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path_3",
    transform: "translate(0 0.3311751075802465) rotate(0 6.012396792419185 12.763661774982515)",
    d: "M0,25.53L12.02,25.53L12.02,0L0,0L0,25.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path_4",
    transform: "translate(0.02611343544093236 0.3311751075802465) rotate(0 6.012248980520455 12.763661774982515)",
    d: "M0,25.53L12.02,25.53L12.02,0L0,0L0,25.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path_5",
    transform: "translate(0 0.1014299008908362) rotate(0 17.658657215141297 4.163131507914198)",
    d: "M0,8.33L35.32,8.33L35.32,0L0,0L0,8.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path_6",
    transform: "translate(0.01892026732648844 0.02182371400967556) rotate(0 17.67625860849853 4.146069275070639)",
    d: "M0,8.29L35.35,8.29L35.35,0L0,0L0,8.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path_7",
    transform: "translate(0.03814690449178902 0.05045087105924962) rotate(0 4.541035026153255 4.540812300319451)",
    d: "M0,9.08L9.08,9.08L9.08,0L0,0L0,9.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path_8",
    transform: "translate(0.0224699992574287 0.07752494231141606) rotate(0 4.955123150569262 4.899369006069955)",
    d: "M0,9.8L9.91,9.8L9.91,0L0,0L0,9.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path_9",
    transform: "translate(0 0) rotate(0 29.999996651785715 29.999996651785715)",
    d: "M0,60L60,60L60,0L0,0L0,60Z"
  }))), /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "translate(0 0)  rotate(0 219 134)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "translate(87.99412785266213 61.69811320754707)  rotate(0 133.5 103)"
  }, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "mask-0",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path_0"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask-0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\u8499\\u7248",
    fillRule: "evenodd",
    style: {
      fill: "#D8D8D8"
    },
    transform: "translate(0 0.4150943396226416)  rotate(0 133.1803016148405 102.5283018867925)",
    opacity: 0,
    d: "M0,205.06L266.36,205.06L266.36,0L0,0L0,205.06Z "
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask-0)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "translate(4 10)  rotate(0 120.5 220)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "translate(22.70382922666986 406.8582093904928)  rotate(0 76.5152091254753 16.0956790123457)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "translate(106.8261848447649 0)  rotate(0 22.90874524714828 16.0956790123457)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill 23",
    fillRule: "evenodd",
    style: {
      fill: "#E5E3EA"
    },
    transform: "translate(0.1919641822241504 3.552713678800501e-15)  rotate(0 22.617504852313424 15.02450425585615)",
    opacity: 1,
    d: "M12.8,27.06C17.67,25.42 19.27,28.46 23.68,29.34C28.09,30.23 36.92,31.01 45.24,26.91C45.19,24.52 44.05,20.98 42.29,20.88C34.22,20.45 29.86,17.97 25.02,14.36C20.99,11.35 18.04,7.07 18.36,0L0.81,0C0.81,0 -0.31,19.21 0.09,26.24C0.09,26.24 7.51,28.83 12.8,27.06Z "
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 25",
    fillRule: "evenodd",
    style: {
      fill: "#7986A8"
    },
    transform: "translate(0.2386760131346257 24.98468848060666)  rotate(0 22.53501755306238 3.3469424524478786)",
    opacity: 1,
    d: "M44.95,1.37C43.05,2.8 29.11,4.1 22.69,3.14C16.27,2.19 17.97,0.9 12.64,1.13C4.77,1.48 0,0 0,0L0.09,4.09C0.09,4.09 3.33,6.11 10.99,4.9C13.5,3.45 17.59,3.41 20.67,5.8C23.8,7.18 32.53,6.62 36.04,6.38C41.74,6 44.36,4.95 44.36,4.95C44.36,4.95 45.42,3.55 44.95,1.37Z "
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 27",
    fillRule: "evenodd",
    style: {
      fill: "#FFFFFF"
    },
    transform: "translate(1.4210854715202e-14 24.92522625083727)  rotate(0 22.813747156213523 1.878526938739963)",
    opacity: 1,
    d: "M0.01,0.18C-0.03,0.3 0.05,0.44 0.17,0.47C0.17,0.47 4.33,1.57 12.14,1.24C15.05,1.11 16.08,1.5 17.53,2.03C18.69,2.47 20.14,3.01 23.03,3.44C24.52,3.66 26.4,3.76 28.43,3.76C35.32,3.76 44.02,2.65 45.53,1.5C45.64,1.42 45.66,1.27 45.58,1.17C45.5,1.06 45.35,1.04 45.24,1.12C43.38,2.52 29.39,3.9 23.1,2.97C20.26,2.54 18.84,2.01 17.69,1.58C16.2,1.03 15.12,0.63 12.11,0.76C4.39,1.1 0.34,0.02 0.3,0.01C0.17,-0.03 0.04,0.05 0.01,0.18Z "
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 29",
    fillRule: "evenodd",
    style: {
      fill: "#C7C4CE"
    },
    transform: "translate(30.62509823422405 22.62420982882239)  rotate(0 6.35825780832085 0.7698249310247415)",
    opacity: 1,
    d: "M12.52,0.47C12.65,0.45 12.74,0.32 12.71,0.19C12.69,0.06 12.56,-0.02 12.43,0C12.36,0.02 4.75,1.47 0.27,0.95C0.14,0.93 0.02,1.02 0,1.16C-0.01,1.29 0.08,1.41 0.21,1.42C0.92,1.5 1.69,1.54 2.51,1.54C6.96,1.54 12.46,0.49 12.52,0.47Z "
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 31",
    fillRule: "evenodd",
    style: {
      fill: "#C7C4CE"
    },
    transform: "translate(0.5004783475138307 13.44505130565289)  rotate(0 4.74409915754303 5.90870101384017)",
    opacity: 1,
    d: "M9.27,11.82C9.4,11.81 9.5,11.69 9.49,11.56C8.81,1.5 0.36,0.02 0.28,0C0.15,-0.02 0.02,0.07 0,0.2C-0.02,0.33 0.07,0.45 0.2,0.48C0.28,0.49 8.36,1.91 9.01,11.59C9.02,11.72 9.12,11.82 9.25,11.82C9.25,11.82 9.27,11.82 9.27,11.82Z "
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 33",
    fillRule: "evenodd",
    style: {
      fill: "#C7C4CE"
    },
    transform: "translate(16.20264819182923 5.343745015754431)  rotate(0 6.70654605907207 10.63414991265356)",
    opacity: 1,
    d: "M13.16,21.08C13.71,18.77 13.83,14.39 8.48,11.11C-0.42,5.65 0.51,0.34 0.52,0.29C0.52,0.29 0.46,0.03 0.33,0.01C0.33,0.01 0.08,0.06 0.05,0.19C0.01,0.42 -0.98,5.87 8.23,11.51C13.07,14.48 13.33,18.3 12.7,20.97C12.66,21.1 12.74,21.23 12.93,21.27C13.04,21.27 13.13,21.19 13.16,21.08Z "
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 35",
    fillRule: "evenodd",
    style: {
      fill: "#C7C4CE"
    },
    transform: "translate(15.90190890475722 9.082996222404475)  rotate(0 2.900453994103092 1.7247470678262615)",
    opacity: 1,
    d: "M1.39,3.34C3.1,1.72 5.79,1.36 5.79,1.36C5.79,1.36 5.97,0.1 5.07,0.01C3.2,-0.18 0.23,2.08 0.23,2.08C-0.45,2.93 0.51,3.75 1.39,3.34Z "
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 37",
    fillRule: "evenodd",
    style: {
      fill: "#C7C4CE"
    },
    transform: "translate(18.23204730387109 11.4281744968699)  rotate(0 2.7624257692808203 1.873110833449479)",
    opacity: 1,
    d: "M1.27,3.64C3.55,1.81 5.51,1.53 5.51,1.53C5.51,1.53 5.72,-0.11 4.35,0.01C2.2,0.19 0.24,2.27 0.24,2.27C-0.42,3.13 0.4,4.06 1.27,3.64Z "
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 39",
    fillRule: "evenodd",
    style: {
      fill: "#C7C4CE"
    },
    transform: "translate(21.23055622633067 13.80356806417798)  rotate(0 2.6571128198419434 1.655268420279193)",
    opacity: 1,
    d: "M1.26,3.21C3.42,1.23 5.3,1.41 5.3,1.41C5.3,1.41 5.52,0.5 4.22,0.06C2.88,-0.39 0.25,1.83 0.25,1.83C-0.42,2.68 0.39,3.62 1.26,3.21Z "
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 41",
    fillRule: "evenodd",
    style: {
      fill: "#C7C4CE"
    },
    transform: "translate(14.56887783404045 6.327329893238113)  rotate(0 3.04057341596093 1.5581059363361125)",
    opacity: 1,
    d: "M1.17,3.06C4.22,1.49 5.65,1.52 5.65,1.52C5.65,1.52 6.76,0.35 5.42,0.07C3.26,-0.38 0.33,1.56 0.33,1.56C-0.44,2.33 0.25,3.36 1.17,3.06Z "
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "translate(0.8153348702130728 0)  rotate(0 22.90874524714829 16.0956790123457)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill 23",
    fillRule: "evenodd",
    style: {
      fill: "#E5E3EA"
    },
    transform: "translate(0.39051660744556926 3.552713678800501e-15)  rotate(0 22.61750485231343 15.02450425585615)",
    opacity: 1,
    d: "M44.42,0L26.88,0C27.2,7.07 24.25,11.35 20.21,14.36C15.38,17.97 11.01,20.45 2.94,20.88C1.18,20.98 0.05,24.52 0,26.91C8.32,31.01 17.15,30.23 21.55,29.34C25.96,28.46 27.56,25.42 32.44,27.06C37.73,28.83 45.15,26.24 45.15,26.24C45.55,19.21 44.42,0 44.42,0Z "
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 25",
    fillRule: "evenodd",
    style: {
      fill: "#7986A8"
    },
    transform: "translate(0.508779375037193 24.98468848060666)  rotate(0 22.53501755306238 3.3469424524478786)",
    opacity: 1,
    d: "M22.38,3.14C15.96,4.1 2.02,2.8 0.12,1.37C-0.35,3.55 0.71,4.95 0.71,4.95C0.71,4.95 3.33,6 9.03,6.38C12.54,6.62 21.27,7.18 24.4,5.8C27.48,3.41 31.57,3.45 34.08,4.9C41.74,6.11 44.98,4.09 44.98,4.09L45.07,0C45.07,0 40.3,1.48 32.43,1.13C27.1,0.9 28.8,2.19 22.38,3.14Z "
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 27",
    fillRule: "evenodd",
    style: {
      fill: "#FFFFFF"
    },
    transform: "translate(0.1899961818695033 24.92522625083727)  rotate(0 22.81374715621353 1.878526938739963)",
    opacity: 1,
    d: "M0.38,1.12C0.28,1.04 0.13,1.06 0.05,1.17C-0.03,1.27 -0.01,1.42 0.1,1.5C1.61,2.65 10.31,3.76 17.2,3.76C19.23,3.76 21.11,3.66 22.6,3.44C25.48,3.01 26.93,2.47 28.1,2.03C29.54,1.5 30.58,1.11 33.49,1.24C41.3,1.57 45.45,0.47 45.45,0.47C45.58,0.44 45.65,0.3 45.62,0.18C45.59,0.05 45.45,-0.03 45.33,0.01C45.29,0.02 41.24,1.1 33.51,0.76C30.51,0.63 29.43,1.03 27.93,1.58C26.79,2.01 25.36,2.54 22.53,2.97C16.24,3.9 2.24,2.52 0.38,1.12Z "
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 29",
    fillRule: "evenodd",
    style: {
      fill: "#C7C4CE"
    },
    transform: "translate(2.475876643430823 22.62420982882239)  rotate(0 6.35825780832085 0.7698249310247415)",
    opacity: 1,
    d: "M12.51,1.42C12.64,1.41 12.73,1.29 12.72,1.16C12.7,1.02 12.58,0.93 12.45,0.95C7.97,1.47 0.36,0.02 0.28,0C0.16,-0.02 0.03,0.06 0,0.19C-0.02,0.32 0.06,0.45 0.19,0.47C0.26,0.49 5.76,1.54 10.21,1.54C11.02,1.54 11.8,1.5 12.51,1.42Z "
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 31",
    fillRule: "evenodd",
    style: {
      fill: "#C7C4CE"
    },
    transform: "translate(35.828813831696685 13.44505130565289)  rotate(0 4.7440991575430305 5.90870101384017)",
    opacity: 1,
    d: "M0.48,11.59C1.13,1.91 9.21,0.49 9.29,0.48C9.42,0.45 9.51,0.33 9.49,0.2C9.46,0.07 9.34,-0.02 9.21,0C9.13,0.02 0.68,1.5 0,11.56C-0.01,11.69 0.09,11.81 0.22,11.82C0.22,11.82 0.23,11.82 0.24,11.82C0.36,11.82 0.47,11.72 0.48,11.59Z "
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 33",
    fillRule: "evenodd",
    style: {
      fill: "#C7C4CE"
    },
    transform: "translate(16.20175018432321 5.343745015754431)  rotate(0 6.70654605907207 10.63414991265356)",
    opacity: 1,
    d: "M0.72,20.97C0.08,18.3 0.34,14.48 5.18,11.51C14.39,5.87 13.41,0.42 13.36,0.19C13.34,0.06 13.08,0.01 13.08,0.01C12.95,0.03 12.89,0.29 12.89,0.29C12.9,0.34 13.83,5.65 4.93,11.11C-0.42,14.39 -0.3,18.77 0.25,21.08C0.28,21.19 0.38,21.27 0.49,21.27C0.67,21.23 0.75,21.1 0.72,20.97Z "
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 35",
    fillRule: "evenodd",
    style: {
      fill: "#C7C4CE"
    },
    transform: "translate(24.114673601333173 9.082996222404475)  rotate(0 2.900453994103092 1.7247470678262615)",
    opacity: 1,
    d: "M0.73,0.01C-0.17,0.1 0.01,1.36 0.01,1.36C0.01,1.36 2.7,1.72 4.41,3.34C5.29,3.75 6.25,2.93 5.57,2.08C5.57,2.08 2.61,-0.18 0.73,0.01Z "
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 37",
    fillRule: "evenodd",
    style: {
      fill: "#C7C4CE"
    },
    transform: "translate(22.060591651863845 11.4281744968699)  rotate(0 2.7624257692808203 1.873110833449479)",
    opacity: 1,
    d: "M1.17,0.01C-0.2,-0.11 0.01,1.53 0.01,1.53C0.01,1.53 1.98,1.81 4.26,3.64C5.13,4.06 5.95,3.13 5.28,2.27C5.28,2.27 3.32,0.19 1.17,0.01Z "
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 39",
    fillRule: "evenodd",
    style: {
      fill: "#C7C4CE"
    },
    transform: "translate(19.272708628282018 13.80356806417798)  rotate(0 2.657112819841945 1.655268420279193)",
    opacity: 1,
    d: "M1.09,0.06C-0.21,0.5 0.01,1.41 0.01,1.41C0.01,1.41 1.9,1.23 4.05,3.21C4.93,3.62 5.74,2.68 5.07,1.83C5.07,1.83 2.44,-0.39 1.09,0.06Z "
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 41",
    fillRule: "evenodd",
    style: {
      fill: "#C7C4CE"
    },
    transform: "translate(25.167465828334265 6.327329893238113)  rotate(0 3.0405734159609317 1.5581059363361125)",
    opacity: 1,
    d: "M0.67,0.07C-0.68,0.35 0.43,1.52 0.43,1.52C0.43,1.52 1.86,1.49 4.91,3.06C5.83,3.36 6.52,2.33 5.75,1.56C5.75,1.56 2.82,-0.38 0.67,0.07Z "
  }))), /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "translate(60.19335948025508 0.2202540682414781)  rotate(0 17.4106463878327 13.33641975308642)"
  }, _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
    id: "mask-1",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path_1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask-1)"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask-1)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill 1",
    fillRule: "evenodd",
    style: {
      fill: "#FFC6A0"
    },
    transform: "translate(0.6905942251138893 0.5444216380577311)  rotate(0 16.783252552026415 12.659035538509794)",
    opacity: 1,
    d: "M10.3,25.32C15.37,25.32 19.42,23.07 26.51,20.02C33.61,16.97 29.04,17.14 20.32,17.14C19.92,15.51 34.71,2.49 33.5,0.66C32.28,-1.17 20.39,1.2 16.74,3.03C13.09,4.86 0.85,15.83 0.85,15.83C-2.6,22.74 5.24,25.32 10.3,25.32Z "
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Fill 3",
    fillRule: "evenodd",
    style: {
      fill: "#FFB69C"
    },
    transform: "translate(74.8444993718751 38.56893461650629)  rotate(0 22.47688617706057 18.39465616797899)",
    opacity: 1,
    d: "M36.25,19.51L35.61,0.72L9.71,0L7.64,17.92C7.61,18.8 6.99,19.56 6.15,19.77C2.13,20.77 0,21.12 0,21.12C0,21.12 2.51,36.79 23.23,36.79C43.95,36.79 44.95,23.65 44.95,23.65C44.95,23.65 41.19,22.35 37.67,21.33C36.85,21.1 36.28,20.36 36.25,19.51Z "
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 9",
    fillRule: "evenodd",
    style: {
      fill: "#FFB69C"
    },
    transform: "translate(49.36832637345012 409.5484619777836)  rotate(0 9.29004028062827 2.9168185666923137)",
    opacity: 1,
    d: "M9.1,5.77C14.23,6.11 18.47,5.11 18.58,3.54C18.68,1.97 14.61,0.41 9.48,0.07C4.35,-0.28 0.11,0.72 0,2.29C-0.1,3.87 3.97,5.42 9.1,5.77Z "
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 11",
    fillRule: "evenodd",
    style: {
      fill: "#E86B6B"
    },
    transform: "translate(50.98409248622277 410.1650330566381)  rotate(0 7.7220339901673 2.1624366429828115)",
    opacity: 1,
    d: "M7.58,4.26C11.85,4.55 15.37,3.84 15.44,2.68C15.52,1.52 12.13,0.35 7.86,0.06C3.6,-0.22 0.08,0.49 0,1.65C-0.08,2.8 3.32,3.98 7.58,4.26Z "
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 13",
    fillRule: "evenodd",
    style: {
      fill: "#FFFFFF"
    },
    transform: "translate(55.7852722163703 411.271072226832)  rotate(0 2.921387478848409 0.9779319609778555)",
    opacity: 1,
    d: "M2.82,1.91C4.44,2.08 5.79,1.8 5.84,1.29C5.89,0.77 4.63,0.22 3.02,0.05C1.41,-0.12 0.05,0.16 0,0.67C-0.05,1.18 1.21,1.74 2.82,1.91Z "
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 19",
    fillRule: "evenodd",
    style: {
      fill: "#FFB594"
    },
    transform: "translate(74.62612091636468 26.22392694859623)  rotate(0 4.049915798996722 6.762094904543865)",
    opacity: 1,
    d: "M8.08,8.46C7.73,3.2 5.23,0.59 5.23,0.59C5.23,0.59 3.74,-0.44 2.23,0.22C0.57,0.95 -0.84,4.72 0.6,8.13C1.4,10.04 3.85,14.54 7.06,13.32C7.06,13.32 8.29,11.62 8.08,8.46Z "
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 21",
    fillRule: "evenodd",
    style: {
      fill: "#FFB594"
    },
    transform: "translate(112.2576265081931 28.20917620835279)  rotate(0 4.274086895541473 6.61085690842565)",
    opacity: 1,
    d: "M7.62,8.38C9.39,5.12 8.35,1.24 6.78,0.35C5.34,-0.47 3.76,0.41 3.76,0.41C3.76,0.41 1.01,2.76 0.14,7.96C-0.38,11.08 0.67,12.89 0.67,12.89C3.75,14.43 6.63,10.2 7.62,8.38Z "
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 23",
    fillRule: "evenodd",
    style: {
      fill: "#FFC6A0"
    },
    transform: "translate(78.93997396331412 6.238930386050312)  rotate(0 18.756723250023857 25.256983033323525)",
    opacity: 1,
    d: "M0.23,23.37C1.05,30.14 1.02,30.01 2.21,36.76C2.75,39.84 8.78,50.04 17.88,50.5C26.38,50.92 33.02,41.59 33.87,38.52C35.65,32.05 35.74,31.9 36.95,25.2C39.43,11.54 33.66,0.75 20.25,0.08L19.34,0.03C5.93,-0.64 -1.44,9.58 0.23,23.37Z "
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 25",
    fillRule: "evenodd",
    style: {
      fill: "#DB836E"
    },
    transform: "translate(86.16787825907271 51.34628830626617)  rotate(0 10.738481950060326 2.9123924347934147)",
    opacity: 1,
    d: "M21.38,0.84C21.23,0.68 20.99,0.67 20.83,0.81C18.55,2.85 14.94,5.24 10.63,5.03C6.25,4.81 2.79,2.23 0.67,0.11C0.51,-0.04 0.27,-0.04 0.11,0.12C-0.04,0.27 -0.04,0.52 0.12,0.67C2.34,2.89 5.96,5.58 10.59,5.81C10.79,5.82 10.99,5.82 11.18,5.82C15.49,5.82 19.07,3.44 21.35,1.4C21.51,1.25 21.52,1 21.38,0.84Z "
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 27",
    fillRule: "evenodd",
    style: {
      fill: "#EA967D"
    },
    transform: "translate(97.96389683548047 5.93570797858472)  rotate(0 0.7378976928270475 0.3823855351414407)",
    opacity: 1,
    d: "M1.48,0.42C1.48,0.26 1.36,0.12 1.2,0.12L0.3,0.07C0.14,0.07 0.01,0.19 0,0.35C-0.01,0.5 0.11,0.64 0.27,0.65L1.17,0.69C1.17,0.69 1.18,0.69 1.19,0.69C1.34,0.69 1.47,0.57 1.48,0.42Z "
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 29",
    fillRule: "evenodd",
    style: {
      fill: "#5C2552"
    },
    transform: "translate(103.0612567251439 29.9795240054713)  rotate(0 2.238468360762859 1.7080965916067206)",
    opacity: 1,
    d: "M2.32,1.05C2.61,1.06 2.89,1.24 3.1,1.55C3.33,1.9 3.46,2.38 3.43,2.87C3.42,3.16 3.64,3.4 3.95,3.42C4.23,3.42 4.46,3.2 4.47,2.92C4.51,2.2 4.33,1.5 3.96,0.96C3.57,0.38 2.99,0.03 2.38,0C1.75,-0.03 1.16,0.25 0.7,0.8C0.29,1.3 0.04,1.97 0,2.7C-0.01,2.98 0.21,3.23 0.5,3.24C0.78,3.26 1.03,3.04 1.04,2.75C1.07,2.26 1.24,1.79 1.5,1.47C1.74,1.18 2.04,1.03 2.32,1.05Z "
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 31",
    fillRule: "evenodd",
    style: {
      fill: "#5C2552"
    },
    transform: "translate(87.07831970649177 29.18097725632528)  rotate(0 2.238453543554918 1.7082741831525896)",
    opacity: 1,
    d: "M4.47,2.92C4.55,1.37 3.61,0.06 2.38,0C1.11,-0.06 0.08,1.15 0,2.7C-0.01,2.98 0.21,3.23 0.5,3.24C0.79,3.26 1.03,3.04 1.04,2.75C1.09,1.79 1.66,1.02 2.32,1.05C2.97,1.08 3.48,1.91 3.43,2.87C3.42,3.16 3.64,3.4 3.95,3.42C4.23,3.42 4.46,3.2 4.47,2.92Z "
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 33",
    fillRule: "evenodd",
    style: {
      fill: "#DB836E"
    },
    transform: "translate(95.71511008533616 27.22156424703354)  rotate(0 2.9814960118161196 6.47218265921869)",
    opacity: 1,
    d: "M5.25,0.17L3.35,3C3.31,3.07 3.29,3.14 3.29,3.21L3.08,12.14L0.41,12.01C0.2,12 0.01,12.16 0,12.38C-0.01,12.6 0.16,12.78 0.37,12.79L3.46,12.94C3.56,12.94 3.65,12.91 3.73,12.84C3.8,12.77 3.85,12.67 3.85,12.56L4.07,3.35L5.9,0.61C6.02,0.43 5.97,0.19 5.79,0.07C5.61,-0.05 5.37,-0.01 5.25,0.17Z "
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 35",
    fillRule: "evenodd",
    style: {
      fill: "#DB836E"
    },
    transform: "translate(95.07332488730147 47.71313372777244)  rotate(0 1.94838916437363 0.4702655420630357)",
    opacity: 1,
    d: "M3.9,0.57C3.91,0.35 3.74,0.17 3.53,0.16L0.41,0C0.2,-0.01 0.01,0.16 0,0.37C-0.01,0.59 0.16,0.77 0.37,0.78L3.49,0.94C3.49,0.94 3.51,0.94 3.51,0.94C3.71,0.94 3.89,0.78 3.9,0.57Z "
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 37",
    fillRule: "evenodd",
    style: {
      fill: "#FFFFFF"
    },
    transform: "translate(91.94848056525252 42.10936580927387)  rotate(0 5.15453261878387 1.6565860608403504)",
    opacity: 1,
    d: "M0,0C2.92,5.09 9.14,3.55 10.31,0.5L0,0Z "
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 39",
    fillRule: "evenodd",
    style: {
      fill: "#DB836E"
    },
    transform: "translate(91.55740297306393 41.71667555246204)  rotate(0 5.545712863688785 2.04961486302237)",
    opacity: 1,
    d: "M6.27123 3.29142C7.90123 3.17142 9.38123 2.35142 10.0812 1.26142L1.13123 0.821421C2.38123 2.56142 4.22123 3.46142 6.27123 3.29142Z M6.33 4.08C8.53 3.9 10.43 2.68 11.07 1.04C11.11 0.92 11.1 0.79 11.03 0.68C10.96 0.57 10.84 0.51 10.72 0.5L0.41 -4.57689e-14C0.26 -4.57689e-14 0.13 0.07 0.06 0.19C-0.02 0.31 -0.02 0.46 0.05 0.59C1.35 2.84 3.42 4.1 5.79 4.1C5.97 4.1 6.15 4.09 6.33 4.08Z "
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 41",
    fillRule: "evenodd",
    style: {
      fill: "#5C2552"
    },
    transform: "translate(77.61450377299661 1.421602412943801)  rotate(0 20.265651891424334 16.37372564100551)",
    opacity: 1,
    d: "M35.27,24.22L36.89,26.2L37.82,32.75C38.63,29.87 39.01,28.14 39.58,25.53C42.28,13.14 39.99,1.09 22.91,0.03C22.91,0.03 16.34,-0.52 7.88,2.88C5.58,3.8 3.83,4.43 2.57,4.84C1.04,5.35 0.01,6.8 0,8.42C-0.05,22.28 1.94,30.96 1.94,30.96L3.15,24.52C3.15,24.52 4.29,22.89 4.37,22.63C4.69,21.67 4.72,17.87 5.82,14.15L34.68,15.6C35.3,20.17 35.27,24.22 35.27,24.22Z "
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 43",
    fillRule: "evenodd",
    style: {
      fill: "#5C2552"
    },
    transform: "translate(83.88263792459149 25.25333007096313)  rotate(0 5.3737288191984 0.936243987557223)",
    opacity: 1,
    d: "M0.38,0.65C0.1,0.73 -0.06,1.02 0.02,1.3C0.1,1.57 0.39,1.73 0.67,1.66L2.21,1.21C2.78,1.36 4.89,1.87 6.95,1.87C8.33,1.87 9.69,1.64 10.56,0.93C10.78,0.74 10.81,0.41 10.63,0.19C10.45,-0.03 10.12,-0.06 9.9,0.12C8.3,1.44 3.9,0.6 2.34,0.16C2.25,0.14 2.15,0.14 2.06,0.16L0.38,0.65Z "
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 45",
    fillRule: "evenodd",
    style: {
      fill: "#5C2552"
    },
    transform: "translate(100.8287313380288 25.99709429805067)  rotate(0 5.27143446477932 1.126430372117836)",
    opacity: 1,
    d: "M10.51,1.92C10.61,1.65 10.48,1.35 10.21,1.24L8.59,0.59C8.51,0.56 8.43,0.55 8.35,0.56C5.94,0.78 1.78,0.85 0.84,0.11C0.62,-0.07 0.29,-0.03 0.11,0.2C-0.07,0.43 -0.03,0.76 0.2,0.93C1.7,2.11 7.23,1.71 8.32,1.61L9.83,2.22C9.89,2.24 9.96,2.25 10.02,2.25C10.23,2.25 10.42,2.13 10.51,1.92Z "
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 47",
    fillRule: "evenodd",
    style: {
      fill: "#EA967D"
    },
    transform: "translate(74.48648496762289 159.37748011502)  rotate(0 5.01564468324185 14.37573079696655)",
    opacity: 1,
    d: "M9.47,28.02C9.45,28.1 9.31,28.17 9.09,28.2C8.94,28.23 8.86,28.52 8.86,28.52C8.88,28.65 9,28.75 9.13,28.75C9.63,28.68 9.91,28.48 10,28.17C10.2,27.5 9.28,26.62 9.06,26.43C5.48,23.97 2.18,17.39 3.46,12.9C6.05,3.81 0.48,0.08 0.42,0.04C0.3,-0.04 0.13,0 0.04,0.13C-0.04,0.26 0,0.43 0.13,0.51C0.18,0.54 5.41,4.05 2.93,12.75C1.59,17.45 5.02,24.32 8.72,26.86C9.08,27.18 9.55,27.77 9.47,28.02Z "
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 49",
    fillRule: "evenodd",
    style: {
      fill: "#EA967D"
    },
    transform: "translate(81.97885595871166 174.2196678681831)  rotate(0 3.3453247795108325 7.397248177311185)",
    opacity: 1,
    d: "M6.68,13.82C6.82,12.96 5.66,12.09 5.56,12.01C0.48,7.13 0.55,0.28 0.55,0.28C0.55,0.13 0.43,0 0.28,0C0.15,0.01 0,0.12 0,0.27C0,0.27 -0.09,7.36 5.21,12.44C5.6,12.72 6.2,13.33 6.13,13.74C6.09,14 5.74,14.16 5.46,14.25C5.31,14.3 5.23,14.46 5.28,14.6C5.28,14.6 5.42,14.79 5.54,14.79L5.62,14.78C6.26,14.58 6.61,14.25 6.68,13.82Z "
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 51",
    fillRule: "evenodd",
    style: {
      fill: "#EA967D"
    },
    transform: "translate(79.49942710697283 174.0654900204141)  rotate(0 3.5435201918817687 7.26876663750366)",
    opacity: 1,
    d: "M5.86,14.34C5.86,14.34 6,14.54 6.12,14.54C6.15,14.54 6.2,14.53 6.2,14.53C6.7,14.39 6.99,14.14 7.07,13.8C7.21,13.16 6.5,12.5 6.4,12.41C0.59,7.83 0.55,0.28 0.55,0.28C0.55,0.13 0.43,0 0.28,0C0.12,0 0,0.12 0,0.27C0,0.27 0.03,8.1 6.05,12.84C6.23,12.99 6.59,13.42 6.53,13.67C6.49,13.84 6.25,13.94 6.05,13.99C5.9,14.03 5.82,14.19 5.86,14.34Z "
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 53",
    fillRule: "evenodd",
    style: {
      fill: "#FFC6A0"
    },
    transform: "translate(0.0003221740818843846 14.78088342957127)  rotate(0 34.70371187908747 38.85037037037037)",
    opacity: 1,
    d: "M65.6,0C65.6,0 46.42,6.96 32.64,11.3C16.44,16.4 3.4,22.84 0.22,34.78C-4.16,51.19 60.2,77.7 60.2,77.7C72.76,76.08 73.84,50.44 54.8,44.75C49.93,40.68 34.8,35.26 34.8,35.26C34.8,35.26 41.94,29.67 50.24,22.96C60.26,14.89 69.39,10.03 69.39,10.03L65.6,0Z "
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 55",
    fillRule: "evenodd",
    style: {
      fill: "#FFC6A0"
    },
    transform: "translate(129.244207883324 65.66943874015745)  rotate(0 20.65860100840244 38.29574498718355)",
    opacity: 1,
    d: "M6.88,43.76C13.92,56.82 26.48,77.19 33.9,76.58C40.52,76.03 43.26,57.77 39.85,48.8C36.43,39.85 21.79,17.83 21.79,17.83C21.79,17.83 18.5,2 4.1,0C4.1,0 -6.77,16.36 6.88,43.76Z "
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "translate(153.9121343672345 74.40304788568096)  rotate(0 43.526615969581755 34.49074074074075)"
  }, _mask3 || (_mask3 = /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path_2"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask-2)"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill 57",
    fillRule: "evenodd",
    style: {
      fill: "#FFC6A0"
    },
    transform: "translate(0.6563443618542866 0.5980318141665993)  rotate(0 43.05913032414967 33.82281476589101)",
    opacity: 1,
    d: "M84.25,6.91C80.27,9.08 72.15,9.08 65.55,6.46C76.39,4.83 77.76,-1.18 74.31,0.2C70.87,1.59 65.78,2.71 60.95,2.02C56.12,1.33 49.03,9.45 49.03,9.45C49.03,9.45 31.93,25.47 14.23,35.43C1.94,42.34 0.72,50.27 0.72,50.27C0.72,50.27 -3.88,68.04 10.12,67.64C24.11,67.24 55.14,20.33 55.14,20.33C55.14,20.33 67.7,20.21 76.66,17.79C85.63,15.37 88.37,4.66 84.25,6.91Z "
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Fill 59",
    fillRule: "evenodd",
    style: {
      fill: "#EA967D"
    },
    transform: "translate(208.7394845112103 86.39748396895938)  rotate(0 15.00090515689068 2.069548969151086)",
    opacity: 1,
    d: "M29.37,0.59C29.44,0.64 29.47,0.79 29.44,1.01C29.42,1.16 29.53,1.3 29.68,1.32C29.68,1.32 29.97,1.23 29.99,1.08C30.04,0.62 29.93,0.29 29.66,0.12C29.07,-0.25 27.97,0.4 27.73,0.56C24.41,3.37 17.21,4.79 13.24,2.35C5.21,-2.59 0.14,1.79 0.09,1.84C-0.02,1.94 -0.03,2.11 0.07,2.23C0.17,2.34 0.35,2.35 0.46,2.25C0.65,2.08 5.29,-1.9 12.95,2.82C14.45,3.74 16.37,4.14 18.38,4.14C21.98,4.14 25.86,2.87 28.06,1.01C28.47,0.75 29.15,0.46 29.37,0.59Z "
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 61",
    fillRule: "evenodd",
    style: {
      fill: "#EA967D"
    },
    transform: "translate(224.9942283347164 82.53207894370955)  rotate(0 7.816190322657505 1.7209393791221785)",
    opacity: 1,
    d: "M15.08,1.39C15.09,1.54 15.2,1.65 15.37,1.65C15.52,1.65 15.64,1.52 15.63,1.36C15.6,0.7 15.39,0.27 14.99,0.09C14.2,-0.28 13.06,0.6 12.96,0.68C6.91,4.29 0.42,2.4 0.35,2.38C0.21,2.34 0.06,2.42 0.01,2.57C-0.03,2.71 0.05,2.87 0.2,2.91C0.2,2.91 2.01,3.44 4.59,3.44C7.03,3.44 10.2,2.97 13.27,1.14C13.65,0.84 14.4,0.42 14.77,0.59C15,0.7 15.07,1.08 15.08,1.39Z "
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 63",
    fillRule: "evenodd",
    style: {
      fill: "#EA967D"
    },
    transform: "translate(224.1812925010775 84.4934403090413)  rotate(0 7.77090469703765 1.8919656897488224)",
    opacity: 1,
    d: "M0.2,3.31C0.24,3.32 1.93,3.78 4.37,3.78C7.06,3.78 10.64,3.21 13.88,0.82C14.09,0.69 14.58,0.46 14.81,0.59C14.96,0.67 14.99,0.93 14.99,1.14C14.99,1.29 15.11,1.41 15.27,1.41C15.42,1.41 15.54,1.29 15.54,1.14C15.54,0.62 15.38,0.27 15.07,0.1C14.5,-0.21 13.67,0.3 13.57,0.37C7.61,4.77 0.42,2.79 0.35,2.77C0.21,2.73 0.05,2.82 0.01,2.96C-0.03,3.11 0.05,3.26 0.2,3.31Z "
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 69",
    fillRule: "evenodd",
    style: {
      fill: "#FFB69C"
    },
    transform: "translate(131.0589160828261 409.5484619777836)  rotate(0 9.29004028064412 2.9168185666923137)",
    opacity: 1,
    d: "M9.1,0.07C3.97,0.41 -0.1,1.97 0,3.54C0.11,5.11 4.35,6.11 9.48,5.77C14.61,5.42 18.68,3.87 18.58,2.29C18.47,0.72 14.23,-0.28 9.1,0.07Z "
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 71",
    fillRule: "evenodd",
    style: {
      fill: "#E86B6B"
    },
    transform: "translate(132.5784008924111 410.1650330566381)  rotate(0 7.7224148202187 2.1624366429828115)",
    opacity: 1,
    d: "M7.58,0.06C3.32,0.35 -0.08,1.52 0,2.68C0.08,3.84 3.6,4.55 7.86,4.26C12.13,3.98 15.52,2.8 15.44,1.65C15.37,0.49 11.85,-0.22 7.58,0.06Z "
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 73",
    fillRule: "evenodd",
    style: {
      fill: "#FFFFFF"
    },
    transform: "translate(137.3788948743745 411.271072226832)  rotate(0 2.921410002436133 0.9779319609778555)",
    opacity: 1,
    d: "M2.82,0.05C1.21,0.22 -0.05,0.77 0,1.29C0.05,1.8 1.41,2.08 3.02,1.91C4.63,1.74 5.9,1.18 5.84,0.67C5.79,0.16 4.44,-0.12 2.82,0.05Z "
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 79",
    fillRule: "evenodd",
    style: {
      fill: "#6297CC"
    },
    transform: "translate(47.03691975689352 170.6084188743074)  rotate(0 52.06954177419835 123.0174386310317)",
    opacity: 1,
    d: "M14.43,30.8C14.43,30.8 12.55,31.84 13.9,34.84L0,242.39C0,242.39 11.05,247.98 24.39,243.85L47.7,54.35C47.95,52.26 49.72,50.68 51.81,50.68C53.9,50.68 55.66,52.26 55.92,54.32L79.69,244.21C79.69,244.21 94,249.6 104.14,241.85L88.65,35.65C89.71,31.47 88.11,30.75 88.11,30.75L84.86,0L17.79,0.2L14.43,30.8Z "
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 81",
    fillRule: "evenodd",
    style: {
      fill: "#E5E3EA"
    },
    transform: "translate(33.71864371006856 52.61403179935841)  rotate(0 23.67492818874241 22.493003759635666)",
    opacity: 1,
    d: "M12.44,1.02C9.92,0.63 8.11,0 8.11,0C8.11,0 5.13,13.15 0,28.61L5.13,31.32C4.59,34.04 8.54,33.55 12.5,35.59C19.18,39.05 26.37,43.78 31.44,44.8C42.53,47.03 50.77,28.53 45.93,14.44C45.93,14.44 43.04,6.22 31.62,4.34C31.62,4.34 19.28,2.98 17.65,1.49C15.22,-1.08 12.44,1.02 12.44,1.02Z "
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 83",
    fillRule: "evenodd",
    style: {
      fill: "#E5E3EA"
    },
    transform: "translate(55.9434797185713 56.07874864935126)  rotate(0 40.416793125954314 59.53815859169205)",
    opacity: 1,
    d: "M77.75,8.11C76.74,7.88 71.88,7.22 65.03,5.85C61.83,5.2 61.17,5.01 59.14,4.1C59.14,4.1 58.32,3.99 58.1,4.19C56.7,5.53 51.32,10.66 41.35,10.66C29.86,10.66 25.37,5.2 24.39,3.77C24.39,3.77 24.01,2.16 23.77,2.12C15.8,1.21 12.34,0.99 8.85,0.29C0.74,-1.35 0,4.47 0,4.47C0,4.47 3.02,51.49 7.88,98.77C7.88,98.77 3.6,109.61 8.67,116.18C8.67,116.18 39.13,122.73 76.02,116.12C80,110.55 75.55,102.16 75.55,102.16C75.55,99.95 76.33,98.96 76.38,96.7C76.43,94.64 75.59,93.02 75.68,91.83C77.75,66.65 80.83,9.18 80.83,9.18C79.7,8.85 78.86,8.35 77.75,8.11Z "
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 85",
    fillRule: "evenodd",
    style: {
      fill: "#E5E3EA"
    },
    transform: "translate(125.1461598233607 64.96316001921886)  rotate(0 18.072802111013544 26.37730467980439)",
    opacity: 1,
    d: "M2.42,30.51C4.09,34.71 7.2,40.46 9.97,45.09C10.38,45.79 10.56,47.12 10.94,47.74C11.4,48.49 12.23,48.62 12.62,49.25C13.94,51.38 14.83,52.75 14.83,52.75C23.62,40.28 36.15,33.89 36.15,33.89C36.15,33.89 35.29,32.6 34.13,30.72C33.56,29.81 33.86,27.93 33.21,26.82C32.49,25.61 30.83,25.16 30.17,23.93C29.38,22.43 28.69,21.01 28.26,19.85C20.55,-0.95 9.41,0.01 9.41,0.01C-1.14,0.01 -1.78,19.98 2.42,30.51Z "
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 87",
    fillRule: "evenodd",
    style: {
      fill: "#E4EBF7"
    },
    transform: "translate(78.60795297637794 64.18778877870709)  rotate(0 2.163563092425747 1.7912380457587245)",
    opacity: 1,
    d: "M4.27,3.4C4.38,3.21 4.32,2.97 4.14,2.86C2.86,2.07 1.69,1.14 0.67,0.12C0.52,-0.04 0.27,-0.04 0.12,0.11C-0.04,0.27 -0.04,0.51 0.11,0.67C1.18,1.74 2.39,2.7 3.73,3.53C3.8,3.56 3.87,3.58 3.94,3.58C4.07,3.58 4.2,3.52 4.27,3.4Z "
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 89",
    fillRule: "evenodd",
    style: {
      fill: "#EA967D"
    },
    transform: "translate(157.3103107482362 110.8464045889616)  rotate(0 5.347527078836405 5.469132193708165)",
    opacity: 1,
    d: "M0.71,10.65C1.84,5 10.41,0.73 10.49,0.69C10.67,0.6 10.75,0.38 10.66,0.2C10.57,0.02 10.36,-0.05 10.18,0.04C9.81,0.22 1.2,4.51 0.01,10.51C-0.03,10.7 0.09,10.89 0.36,10.94C0.53,10.94 0.68,10.82 0.71,10.65Z "
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 91",
    fillRule: "evenodd",
    style: {
      fill: "#4670B2"
    },
    transform: "translate(97.69184138917997 182.8996665616798)  rotate(0 0.38097062962187067 2.88892271799358)",
    opacity: 1,
    d: "M0.71,5.44L0.71,0.34C0.71,0.15 0.57,0 0.38,0C0.2,0 0.05,0.15 0.05,0.34L0.05,5.44C0.05,5.63 0.2,5.78 0.38,5.78C0.57,5.78 0.71,5.63 0.71,5.44Z "
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 93",
    fillRule: "evenodd",
    style: {
      fill: "#4670B2"
    },
    transform: "translate(97.87048035525243 182.8995136074657)  rotate(0 3.759360108592773 15.069049168853894)",
    opacity: 1,
    d: "M0.33,30.14C0.34,30.14 0.36,30.14 0.36,30.14C0.63,30.11 6.96,29.48 7.13,25.89C7.51,17.73 7.52,0.51 7.52,0.33C7.52,0.15 7.37,0 7.18,0C7,0 6.85,0.15 6.85,0.33C6.85,0.51 6.85,17.71 6.46,25.86C6.32,28.87 0.36,29.46 0.3,29.47C0.12,29.49 -0.02,29.65 0,29.83C0.02,30.01 0.16,30.14 0.33,30.14Z "
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 95",
    fillRule: "evenodd",
    style: {
      fill: "#4670B2"
    },
    transform: "translate(117.4867617635242 208.438575840066)  rotate(0 2.4969128512494834 1.388369799418797)",
    opacity: 1,
    d: "M0.48,2.74L4.81,0.64C4.97,0.56 5.04,0.35 4.96,0.19C4.88,0.02 4.68,-0.05 4.51,0.03L0.19,2.14C0.02,2.22 -0.05,2.42 0.03,2.59C0.09,2.71 0.21,2.78 0.33,2.78C0.38,2.78 0.43,2.77 0.48,2.74Z "
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 97",
    fillRule: "evenodd",
    style: {
      fill: "#4670B2"
    },
    transform: "translate(102.0448030389351 212.0813334020373)  rotate(0 6.477499991513105 3.326682077050748)",
    opacity: 1,
    d: "M0.48,6.62L12.77,0.64C12.93,0.56 13,0.35 12.92,0.19C12.84,0.02 12.64,-0.05 12.48,0.03L0.19,6.02C0.02,6.1 -0.05,6.3 0.03,6.46C0.09,6.58 0.21,6.65 0.33,6.65C0.33,6.65 0.43,6.64 0.48,6.62Z "
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 99",
    fillRule: "evenodd",
    style: {
      fill: "#4670B2"
    },
    transform: "translate(80.12326474122546 192.5257635462234)  rotate(0 9.14163877456255 14.18497381160688)",
    opacity: 1,
    d: "M17.95,0C17.77,0 17.62,0.33 17.62,0.33L17.62,27.48L0.49,18.31C0.33,18.22 0.13,18.28 0.04,18.45C-0.05,18.61 0.01,18.81 0.18,18.9L17.79,28.33C17.84,28.36 17.95,28.37 17.95,28.37L18.12,28.32C18.22,28.26 18.28,28.04 18.28,28.04L18.28,0.33C18.28,0.33 18.13,0 17.95,0Z "
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 101",
    fillRule: "evenodd",
    style: {
      fill: "#4670B2"
    },
    transform: "translate(77.28542508358179 221.5921511138009)  rotate(0 1.816344880191757 0.46977916459275093)",
    opacity: 1,
    d: "M0.36,0.94L3.33,0.67C3.51,0.65 3.65,0.49 3.63,0.3C3.61,0.12 3.46,-0.01 3.27,0L0.3,0.27C0.12,0.29 -0.02,0.45 0,0.63C0.02,0.81 0.16,0.94 0.33,0.94L0.36,0.94Z "
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 103",
    fillRule: "evenodd",
    style: {
      fill: "#4670B2"
    },
    transform: "translate(84.30069445156478 220.2899430883184)  rotate(0 5.486996896598465 0.8026236964356885)",
    opacity: 1,
    d: "M10.67,0.67C10.85,0.65 10.99,0.49 10.97,0.31C10.96,0.12 10.8,-0.02 10.61,0L0.3,0.94C0.12,0.95 -0.02,1.12 0,1.3C0.02,1.47 0.16,1.61 0.33,1.61L10.67,0.67Z "
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 105",
    fillRule: "evenodd",
    style: {
      fill: "#4670B2"
    },
    transform: "translate(68.33088790887105 270.9516860893496)  rotate(0 9.168390296567615 69.78485012534566)",
    opacity: 1,
    d: "M0.67,139.28L7.05,87.57L18.33,0.38C18.33,0.38 18.23,0.03 18.05,0C17.86,-0.01 17.69,0.11 17.67,0.29L6.39,87.48L0,139.19C0,139.19 0.11,139.54 0.34,139.57C0.5,139.57 0.67,139.28 0.67,139.28Z "
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 107",
    fillRule: "evenodd",
    style: {
      fill: "#4670B2"
    },
    transform: "translate(86.5922116788266 261.2660246071283)  rotate(0 0.6645393885066825 2.8892483438549164)",
    opacity: 1,
    d: "M0.66,5.49L1.33,0.38C1.35,0.19 1.22,0.03 1.04,0C0.85,-0.02 0.69,0.11 0.66,0.29L0,5.4C-0.02,5.58 0.11,5.75 0.29,5.78C0.31,5.78 0.32,5.78 0.33,5.78C0.5,5.78 0.64,5.66 0.66,5.49Z "
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 109",
    fillRule: "evenodd",
    style: {
      fill: "#4670B2"
    },
    transform: "translate(87.75181008126971 231.4273229747388)  rotate(0 2.0158355855318106 13.32944971706334)",
    opacity: 1,
    d: "M0.66,26.37L4.03,0.38C4.05,0.19 3.92,0.03 3.74,0C3.55,-0.02 3.39,0.11 3.37,0.29L0,26.28C-0.02,26.46 0.11,26.63 0.29,26.66C0.31,26.66 0.33,26.66 0.33,26.66C0.5,26.66 0.64,26.54 0.66,26.37Z "
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 111",
    fillRule: "evenodd",
    style: {
      fill: "#4670B2"
    },
    transform: "translate(91.70216761373696 220.6905230912802)  rotate(0 9.379031527760825 18.378213589967913)",
    opacity: 1,
    d: "M0.29,6.87C0.48,6.89 0.64,6.76 0.67,6.58C1.1,3.21 3.98,0.67 7.37,0.67C10.73,0.67 13.61,3.2 14.06,6.55L18.09,36.47C18.12,36.64 18.26,36.76 18.42,36.76C18.65,36.73 18.75,36.38 18.75,36.38L14.73,6.45C14.23,2.78 11.07,0 7.37,0C3.65,0 0.48,2.79 0,6.49C0,6.49 0.11,6.84 0.29,6.87Z "
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 113",
    fillRule: "evenodd",
    style: {
      fill: "#4670B2"
    },
    transform: "translate(110.2411523728804 260.1083400526546)  rotate(0 0.72880690663942 3.2682941789803976)",
    opacity: 1,
    d: "M1.17,6.53C1.35,6.51 1.48,6.34 1.45,6.16L0.66,0.29C0.64,0.11 0.47,-0.02 0.29,0C0.11,0.03 -0.02,0.2 0,0.38L0.79,6.25C0.82,6.41 0.96,6.54 1.12,6.54C1.14,6.54 1.15,6.54 1.17,6.53Z "
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 115",
    fillRule: "evenodd",
    style: {
      fill: "#4670B2"
    },
    transform: "translate(111.4863953426884 269.3583262258384)  rotate(0 8.92256862541038 69.8448643236512)",
    opacity: 1,
    d: "M17.84,139.31L0.67,0.29C0.67,0.29 0.47,-0.01 0.29,0C0.11,0.03 0,0.38 0,0.38L17.18,139.4C17.18,139.4 17.34,139.69 17.51,139.69C17.73,139.66 17.84,139.31 17.84,139.31Z "
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 117",
    fillRule: "evenodd",
    style: {
      fill: "#4670B2"
    },
    transform: "translate(126.4614012697447 181.1803082414698)  rotate(0 3.8571202007950167 9.985998250218715)",
    opacity: 1,
    d: "M7.7,19.73C7.75,19.56 7.65,19.37 7.48,19.32C1.08,17.35 0.67,0.33 0.67,0.33C0.66,0.14 0.53,0 0.33,0C0.14,0 0,0.16 0,0.34C0.01,1.06 0.43,17.85 7.28,19.96C7.32,19.97 7.35,19.97 7.38,19.97C7.52,19.97 7.66,19.88 7.7,19.73Z "
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 119",
    fillRule: "evenodd",
    style: {
      fill: "#4670B2"
    },
    transform: "translate(61.95244776891218 182.211398284629)  rotate(0 3.599077681149808 9.34028919247699)",
    opacity: 1,
    d: "M0.47,18.65C7.49,15.5 7.21,0.95 7.19,0.33C7.19,0.14 7.03,-0.01 6.85,0C6.67,0.01 6.52,0.16 6.53,0.34C6.53,0.49 6.81,15.07 0.2,18.04C0.03,18.11 -0.05,18.31 0.03,18.48C0.08,18.61 0.21,18.68 0.33,18.68C0.33,18.68 0.43,18.67 0.47,18.65Z "
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 121",
    fillRule: "evenodd",
    style: {
      fill: "#4670B2"
    },
    transform: "translate(142.984323060076 408.2305977884688)  rotate(0 3.6447788888194594 1.4973419223302076)",
    opacity: 1,
    d: "M7.11,0.63C7.27,0.55 7.34,0.34 7.25,0.18C7.16,0.02 6.96,-0.05 6.8,0.04C4.84,1.08 2.64,1.85 0.27,2.33C0.09,2.37 -0.03,2.54 0.01,2.73C0.04,2.88 0.18,2.99 0.33,2.99C2.83,2.5 5.09,1.7 7.11,0.63Z "
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 123",
    fillRule: "evenodd",
    style: {
      fill: "#4670B2"
    },
    transform: "translate(126.5101491115279 409.8022679940893)  rotate(0 7.06222598285965 1.124062573384009)",
    opacity: 1,
    d: "M13.83,2.04C14.01,2.02 14.14,1.86 14.12,1.67C14.1,1.49 13.94,1.36 13.75,1.38C6.3,2.24 0.51,0.04 0.45,0.02C0.28,-0.04 0.09,0.04 0.02,0.21C-0.04,0.39 0.04,0.58 0.21,0.65C0.26,0.67 4.42,2.25 10.24,2.25C11.38,2.25 12.58,2.19 13.83,2.04Z "
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 125",
    fillRule: "evenodd",
    style: {
      fill: "#4670B2"
    },
    transform: "translate(62.15706385309133 410.1460414386158)  rotate(0 4.815350092293187 0.826791634147895)",
    opacity: 1,
    d: "M0.35,1.65C1.8,1.59 6.73,1.32 9.38,0.66C9.56,0.62 9.67,0.43 9.62,0.25C9.58,0.08 9.39,-0.03 9.22,0.01C6.63,0.65 1.75,0.92 0.32,0.98C0.13,0.99 -0.01,1.15 0,1.33C0.01,1.51 0.16,1.65 0.33,1.65C0.34,1.65 0.35,1.65 0.35,1.65Z "
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 127",
    fillRule: "evenodd",
    style: {
      fill: "#4670B2"
    },
    transform: "translate(53.65219152181478 410.290941604201)  rotate(0 3.490916435464058 0.755297515193206)",
    opacity: 1,
    d: "M6.98,1.19C6.99,1.01 6.85,0.85 6.67,0.84C4.59,0.72 2.48,0.44 0.4,0.01C0.22,-0.03 0.04,0.09 0.01,0.27C-0.03,0.45 0.09,0.62 0.27,0.66C2.37,1.1 4.52,1.39 6.65,1.51C6.82,1.51 6.97,1.37 6.98,1.19Z "
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 129",
    fillRule: "evenodd",
    style: {
      fill: "#4670B2"
    },
    transform: "translate(47.63310300534808 408.5249480556225)  rotate(0 2.2523120008075104 0.959865873034431)",
    opacity: 1,
    d: "M4.49,1.67C4.54,1.49 4.43,1.31 4.26,1.26C1.9,0.64 0.48,0.03 0.46,0.03C0.3,-0.05 0.1,0.03 0.03,0.2C-0.05,0.37 0.03,0.57 0.2,0.64C0.26,0.67 1.68,1.27 4.09,1.91C4.11,1.92 4.14,1.92 4.17,1.92C4.32,1.92 4.45,1.82 4.49,1.67Z "
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 131",
    fillRule: "evenodd",
    style: {
      fill: "#C2C0CC"
    },
    transform: "translate(83.54414620295732 64.7637065741347)  rotate(0 15.717429087390196 3.2668029975637225)",
    opacity: 1,
    d: "M31.34,0.47C31.45,0.38 31.47,0.2 31.37,0.09C31.27,-0.02 31.1,-0.03 30.99,0.07C28.49,2.28 22.94,5.99 13.89,5.99C8.63,5.99 4.09,5.02 0.39,3.09C0.26,3.02 0.1,3.08 0.03,3.21C-0.04,3.34 0.01,3.5 0.14,3.57C3.92,5.54 8.54,6.53 13.89,6.53C23.12,6.53 28.79,2.74 31.34,0.47Z "
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 133",
    fillRule: "evenodd",
    style: {
      fill: "#C2C0CC"
    },
    transform: "translate(132.6418412520125 88.27289866612146)  rotate(0 1.4445348417789174 16.969676907825804)",
    opacity: 1,
    d: "M0.54,33.69L2.89,0.29C2.9,0.14 2.79,0.01 2.64,0C2.49,-0.01 2.36,0.11 2.35,0.25L0,33.65C-0.01,33.8 0.1,33.93 0.27,33.94C0.41,33.94 0.53,33.83 0.54,33.69Z "
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 135",
    fillRule: "evenodd",
    style: {
      fill: "#C2C0CC"
    },
    transform: "translate(57.6866276529943 91.80968152932313)  rotate(0 1.7964438877463884 12.57379974860759)",
    opacity: 1,
    d: "M3.36,25.15C3.5,25.13 3.59,24.84 3.59,24.84L0.54,0.24C0.52,0.09 0.38,-0.02 0.24,0C0.09,0.02 0,0.3 0,0.3L3.06,24.91C3.07,25.05 3.19,25.15 3.32,25.15C3.33,25.15 3.36,25.15 3.36,25.15Z "
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 137",
    fillRule: "evenodd",
    style: {
      fill: "#C2C0CC"
    },
    transform: "translate(151.5278572339473 96.22974027290158)  rotate(0 3.54906487050404 2.060880298078203)",
    opacity: 1,
    d: "M0.42,4.08C2.56,2.62 4.75,1.42 6.93,0.52C7.07,0.46 7.13,0.31 7.08,0.17C7.02,0.03 6.86,-0.04 6.73,0.02C4.51,0.93 2.29,2.15 0.12,3.63C0,3.71 -0.04,3.88 0.05,4C0.1,4.08 0.18,4.12 0.27,4.12C0.32,4.12 0.37,4.11 0.42,4.08Z "
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 139",
    fillRule: "evenodd",
    style: {
      fill: "#C2C0CC"
    },
    transform: "translate(138.1223772194954 101.0137945364112)  rotate(0 6.132389989071385 6.42464960843484)",
    opacity: 1,
    d: "M0.5,12.73C0.5,12.73 4.96,5.91 12.16,0.49C12.28,0.4 12.3,0.23 12.21,0.11C12.12,-0.01 11.95,-0.04 11.83,0.05C4.56,5.53 0.09,12.36 0.04,12.43C-0.04,12.56 0,12.72 0.12,12.81L0.27,12.85C0.36,12.85 0.44,12.81 0.5,12.73Z "
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 141",
    fillRule: "evenodd",
    style: {
      fill: "#C2C0CC"
    },
    transform: "translate(135.7730263074548 73.73606125939061)  rotate(0 0.8748086919933655 10.879342225364475)",
    opacity: 1,
    d: "M0.53,21.55C3.26,10.22 0.56,0.3 0.53,0.2C0.49,0.05 0.34,-0.03 0.2,0.01C0.05,0.05 -0.03,0.2 0.01,0.34C0.04,0.44 2.7,10.23 0.01,21.42C-0.03,21.57 0.06,21.72 0.21,21.75C0.23,21.76 0.25,21.76 0.27,21.76C0.39,21.76 0.5,21.68 0.53,21.55Z "
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 143",
    fillRule: "evenodd",
    style: {
      fill: "#C2C0CC"
    },
    transform: "translate(56.3818453819415 67.37403861154884)  rotate(0 0.827675764898018 11.773688049139535)",
    opacity: 1,
    d: "M1.44,23.54C1.59,23.51 1.68,23.37 1.65,23.22C-0.4,13.21 1.01,0.43 1.03,0.3C1.04,0.15 0.94,0.02 0.79,0C0.64,-0.01 0.51,0.09 0.49,0.24C0.47,0.37 -0.94,13.23 1.12,23.33C1.15,23.46 1.26,23.55 1.38,23.55C1.4,23.55 1.42,23.55 1.44,23.54Z "
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 145",
    fillRule: "evenodd",
    style: {
      fill: "#C2C0CC"
    },
    transform: "translate(92.71425647508464 124.8133399463804)  rotate(0 11.42604119370233 4.593088043724329)",
    opacity: 1,
    d: "M22.75,0.48C22.87,0.39 22.89,0.22 22.79,0.1C22.7,-0.02 22.53,-0.03 22.41,0.06C14.73,6.23 0.37,8.62 0.23,8.65C0.08,8.67 -0.02,8.81 0,8.96C0.03,9.09 0.27,9.19 0.27,9.19C0.46,9.16 14.96,6.74 22.75,0.48Z "
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 147",
    fillRule: "evenodd",
    style: {
      fill: "#C2C0CC"
    },
    transform: "translate(83.71060881434522 137.779400422514)  rotate(0 15.73229781053625 1.083449488363897)",
    opacity: 1,
    d: "M31.27,0.53C31.41,0.49 31.49,0.34 31.46,0.2C31.41,0.06 31.27,-0.03 31.12,0.01C19.95,3.1 0.5,0.81 0.3,0.79C0.3,0.79 0.02,0.88 0,1.02C-0.02,1.17 0.09,1.31 0.24,1.33C0.36,1.34 7.37,2.17 15.41,2.17C20.83,2.17 26.72,1.79 31.27,0.53Z "
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 149",
    fillRule: "evenodd",
    style: {
      fill: "#192064"
    },
    transform: "translate(200.2090594246279 84.22886470943924)  rotate(0 5.82807736542351 7.22912070319036)",
    opacity: 1,
    d: "M11.52,12.33C11.81,11.87 11.63,11.26 11.13,11.03C5.22,8.37 3.26,2.41 2.75,0.34C2.67,0.02 2.28,-0.11 2.02,0.11C1.57,0.5 0.9,1.08 0.18,1.77C0.07,1.87 -0.02,2.02 0,2.17C1.17,9.65 7.23,13.51 8.86,14.33C9.39,14.59 10.05,14.45 10.4,13.97C10.86,13.37 11.24,12.79 11.52,12.33Z "
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 151",
    fillRule: "evenodd",
    style: {
      fill: "#C1C4D6"
    },
    transform: "translate(206.0846144055567 94.06057052201808)  rotate(0 0.4769752282865767 0.4787466899970667)",
    opacity: 1,
    d: "M0.48,0C0.21,0 0,0.21 0,0.48C0,0.74 0.21,0.96 0.48,0.96C0.74,0.96 0.95,0.74 0.95,0.48C0.95,0.21 0.74,0 0.48,0Z "
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 153",
    fillRule: "evenodd",
    style: {
      fill: "#C1C4D6"
    },
    transform: "translate(207.9928200952068 95.34982159230096)  rotate(0 0.4769752282865767 0.4787466899970667)",
    opacity: 1,
    d: "M0.48,0C0.21,0 0,0.21 0,0.48C0,0.74 0.21,0.96 0.48,0.96C0.74,0.96 0.95,0.74 0.95,0.48C0.95,0.21 0.74,0 0.48,0Z "
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 155",
    fillRule: "evenodd",
    style: {
      fill: "#5C2552"
    },
    transform: "translate(63.82042845663305 172.2017429221347)  rotate(0 34.423363180743095 5.522921745892875)",
    opacity: 1,
    d: "M68.85,8.28C68.55,3.57 68.21,0 68.21,0C68.21,0 39.41,4.78 0.81,0.1C0.34,4.52 0,8.28 0,8.28C0,8.28 34.18,14.5 68.85,8.28Z "
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 157",
    fillRule: "evenodd",
    style: {
      fill: "#FFFFFF"
    },
    transform: "translate(89.02102605311218 173.0190299009385)  rotate(0 8.782134954043295 6.19752114083164)",
    opacity: 1,
    d: "M0,10.73C0,11.55 0.64,12.23 1.46,12.26C6.01,12.42 10.92,12.45 16.09,12.27C16.91,12.24 17.56,11.56 17.56,10.74L17.56,1.55C17.56,0.69 16.87,0 16.01,0.02C11.56,0.14 6.72,0.15 1.57,0C0.71,-0.02 0,0.66 0,1.52L0,10.73Z "
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 159",
    fillRule: "evenodd",
    style: {
      fill: "#5C2552"
    },
    transform: "translate(91.10554495015118 175.0811071690412)  rotate(0 6.643746809975745 4.136914729499267)",
    opacity: 1,
    d: "M0,6.97C0,7.62 0.51,8.16 1.16,8.18C4.57,8.29 8.24,8.31 12.11,8.19C12.76,8.17 13.29,7.63 13.29,6.98L13.29,1.22C13.29,0.54 12.74,0 12.06,0.01C8.72,0.09 5.1,0.1 1.24,0C0.56,-0.02 0,0.53 0,1.21L0,6.97Z "
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 161",
    fillRule: "evenodd",
    style: {
      fill: "#C2C0CC"
    },
    transform: "translate(38.85326368243783 58.44497992778791)  rotate(0 3.3097285708723443 12.06849432307016)",
    opacity: 1,
    d: "M0.53,23.94C3.34,13.75 6.58,0.47 6.61,0.34C6.61,0.34 6.56,0.04 6.41,0.01C6.27,-0.03 6.12,0.06 6.09,0.21C6.05,0.34 2.81,13.61 0.01,23.79C0.01,23.79 0.05,24.09 0.2,24.13L0.27,24.14C0.39,24.14 0.5,24.06 0.53,23.94Z "
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 163",
    fillRule: "evenodd",
    style: {
      fill: "#C2C0CC"
    },
    transform: "translate(50.97578698641178 79.6132462164832)  rotate(0 3.3783075274450916 6.95706295766682)",
    opacity: 1,
    d: "M6.61,13.88C6.74,13.81 6.8,13.65 6.73,13.52C3.64,7.58 0.55,0.24 0.52,0.17C0.46,0.03 0.3,-0.04 0.17,0.02C0.03,0.08 -0.04,0.24 0.02,0.38C0.05,0.45 3.15,7.81 6.25,13.77C6.3,13.86 6.39,13.91 6.49,13.91C6.53,13.91 6.57,13.9 6.61,13.88Z "
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 165",
    fillRule: "evenodd",
    style: {
      fill: "#EA967D"
    },
    transform: "translate(18.22753176239125 50.49006805699606)  rotate(0 8.060892520792356 4.4324809321318845)",
    opacity: 1,
    d: "M16,0.64C16.15,0.5 16.16,0.28 16.03,0.13C15.9,-0.03 15.68,-0.04 15.53,0.09C15.43,0.17 5.85,8.39 0.38,8.14C0.17,8.12 0.01,8.28 0,8.48C-0.01,8.68 0.15,8.85 0.34,8.86C0.44,8.86 0.54,8.86 0.63,8.86C6.41,8.86 15.6,0.98 16,0.64Z "
  })))), /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "translate(38 51)  rotate(0 25 16.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill 1",
    fillRule: "evenodd",
    style: {
      fill: "#CED0DB"
    },
    transform: "translate(15.77135150702058 0.2912942734193975)  rotate(0 8.177737818455116 16.312479311486264)",
    opacity: 1,
    d: "M0,32.62L6.16,32.62L16.36,0L10.19,0L0,32.62Z "
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "translate(0 3.786825554452169)  rotate(0 25 13)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "translate(0 0)  rotate(0 6.5 13)"
  }, _mask4 || (_mask4 = /*#__PURE__*/React.createElement("mask", {
    id: "mask-3",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path_3"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask-3)"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask-3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill 2",
    fillRule: "evenodd",
    style: {
      fill: "#E4E6EF"
    },
    transform: "translate(-0.0001970825316695861 0.3311751075802465)  rotate(0 6.012495333684995 12.763661774982515)",
    opacity: 1,
    d: "M4.78,0L0.59,0C0.26,0 0,0.27 0,0.6L0,4.86L0,20.67L0,24.92C0,25.26 0.26,25.53 0.59,25.53L4.78,25.53L11.43,25.53C11.76,25.53 12.02,25.26 12.02,24.92L12.02,21.27C12.02,20.94 11.76,20.67 11.43,20.67L4.78,20.67L4.78,4.86L11.43,4.86C11.76,4.86 12.02,4.59 12.02,4.26L12.02,0.6C12.02,0.27 11.76,0 11.43,0L4.78,0Z "
  }))), /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "translate(36.26318581981609 0)  rotate(0 6.5 13)"
  }, _mask5 || (_mask5 = /*#__PURE__*/React.createElement("mask", {
    id: "mask-4",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path_4"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask-4)"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask-4)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill 4",
    fillRule: "evenodd",
    style: {
      fill: "#E4E6EF"
    },
    transform: "translate(0.02611343544093236 0.3311751075802465)  rotate(0 6.01249533368498 12.763661774982515)",
    opacity: 1,
    d: "M0.59,0C0.26,0 0,0.27 0,0.6L0,4.26C0,4.59 0.26,4.86 0.59,4.86L7.24,4.86L7.24,20.67L0.59,20.67C0.26,20.67 0,20.94 0,21.27L0,24.92C0,25.26 0.26,25.53 0.59,25.53L7.24,25.53L11.43,25.53C11.76,25.53 12.02,25.26 12.02,24.92L12.02,21.27L12.02,4.26L12.02,0.6C12.02,0.27 11.76,0 11.43,0L7.24,0L0.59,0Z "
  }))))), /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "translate(317 184)  rotate(0 19 41.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill 1",
    fillRule: "evenodd",
    style: {
      fill: "#5BA02E"
    },
    transform: "translate(15.95051344645864 4.618527782440651e-13)  rotate(0 6.066770751476075 24.01986696294488)",
    opacity: 1,
    d: "M12.13,6.05C12.13,2.71 9.43,0 6.04,0C2.7,0 0,2.71 0,6.05L0,48.04L12.13,48.04L12.13,6.05Z "
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 3",
    fillRule: "evenodd",
    style: {
      fill: "#92C110"
    },
    transform: "translate(22.21084194710786 30.27706089188402)  rotate(0 6.11603087612955 13.985257320619464)",
    opacity: 1,
    d: "M12.23,5.92C12.23,2.65 9.58,0 6.3,0L5.93,0C2.66,0 0,2.65 0,5.92L0,27.97L12.23,27.97L12.23,5.92Z "
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 5",
    fillRule: "evenodd",
    style: {
      fill: "#92C110"
    },
    transform: "translate(4.011920803502584 18.0771555696412)  rotate(0 6.11603087612955 14.87793331980794)",
    opacity: 1,
    d: "M12.23,5.92C12.23,2.65 9.59,0 6.32,0L5.91,0C2.65,0 0,2.65 0,5.92L0,29.76L12.23,29.76L12.23,5.92Z "
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 7",
    fillRule: "evenodd",
    style: {
      fill: "#CAD5EE"
    },
    transform: "translate(0 47)  rotate(0 19 18)",
    opacity: 1,
    d: "M35.62,36C36.94,36 38,34.98 38,33.74L38,2.26C38,1.02 36.94,0 35.62,0L2.38,0C1.06,0 0,1.02 0,2.26L0,33.74C0,34.98 1.06,36 2.38,36L35.62,36Z "
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 9",
    fillRule: "evenodd",
    style: {
      fill: "#92C110"
    },
    transform: "translate(17.73569740359849 7.960160912171537)  rotate(0 1.19337187826918 1.190234665584635)",
    opacity: 1,
    d: "M1.19,0C0.53,0 0,0.53 0,1.19C0,1.85 0.53,2.38 1.19,2.38C1.85,2.38 2.39,1.85 2.39,1.19C2.39,0.53 1.85,0 1.19,0Z "
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 11",
    fillRule: "evenodd",
    style: {
      fill: "#92C110"
    },
    transform: "translate(24.00089976451149 20.16006623441409)  rotate(0 1.1933718782691816 1.190234665584635)",
    opacity: 1,
    d: "M1.19,0C0.53,0 0,0.53 0,1.19C0,1.85 0.53,2.38 1.19,2.38C1.85,2.38 2.39,1.85 2.39,1.19C2.39,0.53 1.85,0 1.19,0Z "
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 13",
    fillRule: "evenodd",
    style: {
      fill: "#5BA02E"
    },
    transform: "translate(5.503635651339347 26.11123956233643)  rotate(0 1.19337187826918 1.1902346655846365)",
    opacity: 1,
    d: "M1.19,0C0.53,0 0,0.53 0,1.19C0,1.85 0.53,2.38 1.19,2.38C1.85,2.38 2.39,1.85 2.39,1.19C2.39,0.53 1.85,0 1.19,0Z "
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 15",
    fillRule: "evenodd",
    style: {
      fill: "#5BA02E"
    },
    transform: "translate(11.47049504268503 38.31114488457899)  rotate(0 1.19337187826918 1.190234665584633)",
    opacity: 1,
    d: "M1.19,0C0.53,0 0,0.53 0,1.19C0,1.85 0.53,2.38 1.19,2.38C1.85,2.38 2.39,1.85 2.39,1.19C2.39,0.53 1.85,0 1.19,0Z "
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.57,
    transform: "translate(360 159)  rotate(0 23.5 13)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "translate(0 0)  rotate(0 18 4.5)"
  }, _mask6 || (_mask6 = /*#__PURE__*/React.createElement("mask", {
    id: "mask-5",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path_5"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask-5)"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask-5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill 1",
    fillRule: "evenodd",
    style: {
      fill: "#E4E6EF"
    },
    transform: "translate(-0.0001047304057627106 0.1014299008908362)  rotate(0 17.658709580344183 4.163131507914198)",
    opacity: 1,
    d: "M31.16,8.31C33.46,8.31 35.32,6.45 35.32,4.16C35.32,1.86 33.46,0 31.16,0L4.15,0.01C1.86,0.01 0,1.88 0,4.17C0,6.47 1.86,8.33 4.16,8.33L31.16,8.31Z "
  }))), /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "translate(10.23823568664088 16.43773584905661)  rotate(0 18 4.5)"
  }, _mask7 || (_mask7 = /*#__PURE__*/React.createElement("mask", {
    id: "mask-6",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path_6"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask-6)"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask-6)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill 3",
    fillRule: "evenodd",
    style: {
      fill: "#E4E6EF"
    },
    transform: "translate(0.01892026732648844 0.02182371400967556)  rotate(0 17.67625860849853 4.146069493537497)",
    opacity: 1,
    d: "M31.2,8.28C33.49,8.28 35.35,6.42 35.35,4.14C35.35,1.85 33.49,0 31.19,0L4.16,0.01C1.86,0.01 0,1.87 0,4.15C0,6.44 1.86,8.29 4.16,8.29L31.2,8.28Z "
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Fill 5",
    fillRule: "evenodd",
    style: {
      fill: "#E4E6EF"
    },
    transform: "translate(16.73077539036435 8.467924528301891)  rotate(0 7.116822367543045 4.109433962264153)",
    opacity: 1,
    d: "M4.1,4.11C4.1,6.37 2.27,8.2 0,8.22L14.23,8.21C11.95,8.21 10.1,6.38 10.1,4.11C10.1,1.84 11.94,0 14.23,0L0,0.01C2.27,0.03 4.1,1.85 4.1,4.11Z "
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "translate(28 191)  rotate(0 47.5 14.5)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "translate(29.96556786333911 18.26415094339623)  rotate(0 5 5)"
  }, _mask8 || (_mask8 = /*#__PURE__*/React.createElement("mask", {
    id: "mask-7",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path_7"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask-7)"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask-7)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill 1",
    fillRule: "evenodd",
    style: {
      fill: "#E4E6EF"
    },
    transform: "translate(0.03814690449178902 0.05045087105924962)  rotate(0 4.541035026153255 4.540891887707012)",
    opacity: 1,
    d: "M5,0.02C2.51,-0.23 0.28,1.58 0.02,4.08C-0.23,6.57 1.58,8.8 4.08,9.06C6.57,9.31 8.8,7.5 9.06,5C9.31,2.51 7.5,0.28 5,0.02Z "
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Fill 3",
    fillRule: "evenodd",
    style: {
      fill: "#E4E6EF"
    },
    transform: "translate(59.09875884158547 1.660377358490566)  rotate(0 4.578072868010143 4.566037735849058)",
    opacity: 1,
    d: "M5.05,0.02C2.53,-0.23 0.28,1.59 0.02,4.1C-0.23,6.61 1.6,8.85 4.11,9.11C6.63,9.36 8.87,7.54 9.13,5.03C9.39,2.52 7.56,0.28 5.05,0.02Z "
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 5",
    fillRule: "evenodd",
    style: {
      fill: "#E4E6EF"
    },
    transform: "translate(0 0)  rotate(0 4.578072868010143 4.566037735849058)",
    opacity: 1,
    d: "M5.05,0.02C2.53,-0.23 0.28,1.59 0.02,4.1C-0.23,6.61 1.6,8.85 4.11,9.11C6.63,9.36 8.87,7.54 9.13,5.03C9.39,2.52 7.56,0.28 5.05,0.02Z "
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "translate(84.07006539436806 11.62264150943396)  rotate(0 5 5)"
  }, _mask9 || (_mask9 = /*#__PURE__*/React.createElement("mask", {
    id: "mask-8",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path_8"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask-8)"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask-8)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill 7",
    fillRule: "evenodd",
    style: {
      fill: "#E4E6EF"
    },
    transform: "translate(0.0224699992574287 0.07752494231141606)  rotate(0 4.955368406139504 4.899369006069955)",
    opacity: 1,
    d: "M5.46,0.03C2.74,-0.25 0.31,1.71 0.03,4.4C-0.25,7.09 1.73,9.5 4.45,9.77C7.17,10.05 9.6,8.09 9.88,5.4C10.16,2.71 8.18,0.3 5.46,0.03Z "
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Fill 9",
    fillRule: "evenodd",
    style: {
      fill: "#E4E6EF"
    },
    transform: "translate(4.994261310556519 4.150943396226416)  rotate(0 42.45122113973041 9.54716981132076)",
    opacity: 1,
    d: "M59.42,2.23L84.74,12.27L84.9,11.86L59.39,1.74L29.62,18.58L0.24,0L0,0.38L29.61,19.09L59.42,2.23Z "
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "translate(252.0629921259842 30)  rotate(0 67 51)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "translate(0 0)  rotate(0 67 51)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\u77E9\\u5F62",
    fillRule: "evenodd",
    style: {
      fill: "#E2E7F2"
    },
    transform: "translate(0 4.48785151856018)  rotate(0 66.51968503937005 48.65699662542183)",
    opacity: 1,
    d: "M3.89,97.31L129.15,97.31C131.29,97.31 133.04,95.57 133.04,93.43L133.04,3.89C133.04,2.86 132.63,1.87 131.9,1.14C131.17,0.41 130.18,0 129.15,0L3.89,0C2.86,0 1.87,0.41 1.14,1.14C0.41,1.87 0,2.86 0,3.89L0,93.43C0,95.57 1.75,97.31 3.89,97.31Z "
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "translate(38.37674136886734 22.61669291338583)  rotate(0 42 35)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill 30",
    fillRule: "evenodd",
    style: {
      fill: "#FFFFFF"
    },
    transform: "translate(0.02166763000771418 0.01597808773898463)  rotate(0 41.80782763693001 34.744656917885266)",
    opacity: 1,
    d: "M82.52,69.49C82.52,69.49 83.62,69.01 83.62,68.42L83.62,1.33C83.62,0.6 83.02,0 82.29,0L1.33,0C0.6,0 0,0.6 0,1.33L0,68.16C0,68.89 0.6,69.49 1.33,69.49L82.52,69.49Z "
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 32",
    fillRule: "evenodd",
    style: {
      fill: "#CED7EC"
    },
    transform: "translate(7.172995206368413 7.077602429696286)  rotate(0 34.84820558968591 22.77979977502813)",
    opacity: 1,
    d: "M68.6,45.56C69.21,45.56 69.7,45.08 69.7,44.49L69.7,1.07C69.7,0.48 69.21,0 68.6,0L1.09,0C0.49,0 0,0.48 0,1.07L0,44.49C0,45.08 0.49,45.56 1.09,45.56L68.6,45.56Z "
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 34",
    fillRule: "evenodd",
    style: {
      fill: "#B2BED9"
    },
    transform: "translate(11.24933155663236 12.05142033745778)  rotate(0 3.06335484987453 0.653667266591678)",
    opacity: 1,
    d: "M6.13,0.65C6.13,0.29 5.83,0 5.46,0L0.67,0C0.3,0 0,0.29 0,0.65C0,1.01 0.3,1.31 0.67,1.31L5.46,1.31C5.83,1.31 6.13,1.01 6.13,0.65Z "
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 36",
    fillRule: "evenodd",
    style: {
      fill: "#B2BED9"
    },
    transform: "translate(11.32679775028117 15.18840850393701)  rotate(0 3.0633548498745373 0.653667266591678)",
    opacity: 1,
    d: "M6.13,0.65C6.13,0.29 5.83,0 5.46,0L0.67,0C0.3,0 0,0.29 0,0.65C0,1.01 0.3,1.31 0.67,1.31L5.46,1.31C5.83,1.31 6.13,1.01 6.13,0.65Z "
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 38",
    fillRule: "evenodd",
    style: {
      fill: "#393D65"
    },
    transform: "translate(7.173132266159 16.64580877390344)  rotate(0 34.76514735658045 18.02442130342617)",
    opacity: 1,
    d: "M16.31,15C5.33,15 7.25,23.96 0,23.96L0,34.92C0,35.51 0.49,35.99 1.1,35.99L68.43,36.05C69.04,36.05 69.53,35.57 69.53,34.98L69.53,20.85C58.57,20.85 60.55,0 51.76,0C43.42,0 44,23.01 35.29,23.01C26.73,23.01 27.3,15 16.31,15Z "
  }), /*#__PURE__*/React.createElement("path", {
    id: "Stroke 40",
    style: {
      stroke: "#FFFFFF",
      strokeWidth: 0.5283325984251969,
      strokeOpacity: 1,
      strokeDasharray: "0 0"
    },
    transform: "translate(6.925711932162574 19.56189145106856)  rotate(0 34.888843817599636 12.252995962376454)",
    d: "M0,24.51C10.96,24.51 9.41,0 16.47,0C23.2,0 21.18,24.51 35.11,24.51C43.68,24.51 46.37,14.52 52.43,14.52C58.48,14.52 62.52,24.51 69.78,24.51 "
  }), /*#__PURE__*/React.createElement("path", {
    id: "Stroke 42",
    style: {
      stroke: "#E4E6EF",
      strokeWidth: 0.9977952755905513,
      strokeOpacity: 1,
      strokeDasharray: "0 0"
    },
    transform: "translate(7.906347321969334 58.90989691788523)  rotate(0 33.80531764298694 0.06681664791901144)",
    d: "M0,0.07L67.61,0.07 "
  }), /*#__PURE__*/React.createElement("path", {
    id: "Stroke 44",
    style: {
      stroke: "#E4E6EF",
      strokeWidth: 0.9977952755905513,
      strokeOpacity: 1,
      strokeDasharray: "0 0"
    },
    transform: "translate(7.906347321969434 63.42500517435327)  rotate(0 28.40262628709873 0.06681664791901144)",
    d: "M0,0.07L56.81,0.07 "
  })), /*#__PURE__*/React.createElement("path", {
    id: "\\u8DEF\\u5F84",
    fillRule: "evenodd",
    style: {
      fill: "#393D65"
    },
    transform: "translate(0 0)  rotate(0 66.48627671541055 6.914186726659165)",
    opacity: 1,
    d: "M0,3.48L0,13.83L132.97,13.83L132.97,3.48C132.97,1.56 131.38,0 129.41,0L3.56,0C1.6,0 0,1.56 0,3.48Z "
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u692D\\u5706\\u5F62",
    fillRule: "evenodd",
    style: {
      fill: "#FFFFFF"
    },
    transform: "translate(5.073610798650169 4.434286839145107)  rotate(0 2.5434870641169853 2.4798998875140605)",
    opacity: 1,
    d: "M5.09,2.48C5.09,1.11 3.95,0 2.54,0C1.14,0 0,1.11 0,2.48C0,3.85 1.14,4.96 2.54,4.96C3.95,4.96 5.09,3.85 5.09,2.48Z "
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u692D\\u5706\\u5F62",
    fillRule: "evenodd",
    style: {
      fill: "#FFFFFF"
    },
    transform: "translate(14.57345331833521 4.434286839145107)  rotate(0 2.5434870641169853 2.4798998875140605)",
    opacity: 1,
    d: "M5.09,2.48C5.09,1.11 3.95,0 2.54,0C1.14,0 0,1.11 0,2.48C0,3.85 1.14,4.96 2.54,4.96C3.95,4.96 5.09,3.85 5.09,2.48Z "
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u692D\\u5706\\u5F62",
    fillRule: "evenodd",
    style: {
      fill: "#FFFFFF"
    },
    transform: "translate(24.07478065241844 4.434286839145107)  rotate(0 2.5434870641169836 2.4798998875140605)",
    opacity: 1,
    d: "M5.09,2.48C5.09,1.11 3.95,0 2.54,0C1.14,0 0,1.11 0,2.48C0,3.85 1.14,4.96 2.54,4.96C3.95,4.96 5.09,3.85 5.09,2.48Z "
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u8DEF\\u5F84",
    fillRule: "evenodd",
    style: {
      fill: "#FFFFFF"
    },
    transform: "translate(42.53547806524184 53.4836085489314)  rotate(0 1.636265466816645 1.198690663667042)",
    opacity: 1,
    d: "M3.27,1.2L1.64,0L0,1.2L1.64,2.4L3.27,1.2Z "
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u77E9\\u5F62",
    fillRule: "evenodd",
    style: {
      fill: "#B2BED9"
    },
    transform: "translate(9.466719736955957 49.6645916760405)  rotate(0 9.51766029246344 2.3430928008998877)",
    opacity: 1,
    d: "M1.05,4.69L17.99,4.69C18.27,4.69 18.54,4.58 18.73,4.38C18.93,4.19 19.04,3.92 19.04,3.64L19.04,1.05C19.04,0.77 18.93,0.5 18.73,0.31C18.54,0.11 18.27,0 17.99,0L1.05,0C0.77,0 0.5,0.11 0.31,0.31C0.11,0.5 0,0.77 0,1.05L0,3.64C0,3.92 0.11,4.19 0.31,4.38C0.5,4.58 0.77,4.69 1.05,4.69Z "
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u77E9\\u5F62",
    fillRule: "evenodd",
    style: {
      fill: "#B2BED9"
    },
    transform: "translate(9.466719736955957 58.68662092238471)  rotate(0 9.51766029246344 2.272155793025872)",
    opacity: 1,
    d: "M1.03,4.54L18,4.54C18.27,4.54 18.54,4.43 18.73,4.24C18.93,4.05 19.04,3.78 19.04,3.51L19.04,1.03C19.04,0.76 18.93,0.49 18.73,0.3C18.54,0.11 18.27,0 18,0L1.03,0C0.46,0 0,0.46 0,1.03L0,3.51C0,4.08 0.46,4.54 1.03,4.54Z "
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u77E9\\u5F62",
    fillRule: "evenodd",
    style: {
      fill: "#B2BED9"
    },
    transform: "translate(9.466719736955957 67.52479302587176)  rotate(0 9.51766029246344 2.272155793025872)",
    opacity: 1,
    d: "M1.03,4.54L18,4.54C18.27,4.54 18.54,4.43 18.73,4.24C18.93,4.05 19.04,3.78 19.04,3.51L19.04,1.03C19.04,0.76 18.93,0.49 18.73,0.3C18.54,0.11 18.27,0 18,0L1.03,0C0.46,0 0,0.46 0,1.03L0,3.51C0,4.08 0.46,4.54 1.03,4.54Z "
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u692D\\u5706\\u5F62",
    fillRule: "evenodd",
    style: {
      fill: "#FFFFFF"
    },
    transform: "translate(9.481567880937959 23.48159730033746)  rotate(0 9.502812148481436 9.2652418447694)",
    opacity: 1,
    d: "M19.01,9.27C19.01,4.15 14.75,0 9.5,0C4.26,0 0,4.15 0,9.27C0,14.38 4.26,18.53 9.5,18.53C14.75,18.53 19.01,14.38 19.01,9.27Z "
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u8DEF\\u5F84",
    fillRule: "evenodd",
    style: {
      fill: "#393D65"
    },
    transform: "translate(11.88102794842952 34.61070693670361)  rotate(0 7.101867266591675 3.700688224614056)",
    opacity: 1,
    d: "M14.2,4.18C12.81,1.61 10.08,0 7.1,0C4.12,0 1.39,1.61 0,4.18C1.76,6.22 4.36,7.4 7.1,7.4C9.84,7.4 12.44,6.22 14.2,4.18Z "
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u692D\\u5706\\u5F62",
    fillRule: "evenodd",
    style: {
      fill: "#393D65"
    },
    transform: "translate(15.46091546249026 28.0099842519685)  rotate(0 3.573948256467942 3.484599550056243)",
    opacity: 1,
    d: "M7.15,3.48C7.15,1.56 5.55,0 3.57,0C1.6,0 0,1.56 0,3.48C0,5.41 1.6,6.97 3.57,6.97C5.55,6.97 7.15,5.41 7.15,3.48Z "
  }))), /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "translate(355 0)  rotate(0 30 30)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "translate(0 0)  rotate(0 30 30)"
  }, _mask10 || (_mask10 = /*#__PURE__*/React.createElement("mask", {
    id: "mask-9",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path_9"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask-9)"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask-9)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill 1",
    fillRule: "evenodd",
    style: {
      fill: "#597EF7"
    },
    transform: "translate(-0.000006696428569747629 -0.000006696428577360588)  rotate(0 30 30)",
    opacity: 1,
    d: "M0,30C0,46.57 13.43,60 30,60C46.57,60 60,46.57 60,30C60,13.43 46.57,0 30,0C13.43,0 0,13.43 0,30Z "
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Fill 3",
    fillRule: "evenodd",
    style: {
      fill: "#FFFFFF"
    },
    transform: "translate(21.15841934530148 16.08448660714286)  rotate(0 9.156360639849265 11.243203124999996)",
    opacity: 1,
    d: "M11.72,18.09C12.08,17.36 12.65,16.67 13.38,16.02C15.32,14.37 16.45,13.31 16.81,12.87C17.79,11.57 18.31,9.91 18.31,7.93C18.31,5.5 17.5,3.56 15.92,2.15C14.31,0.69 12.2,0 9.57,0C6.62,0 4.27,0.85 2.57,2.59C0.98,4.14 0.14,6.2 0,8.79C-0.02,9.2 0.31,9.55 0.73,9.55L3.57,9.55C3.95,9.55 4.27,9.25 4.29,8.87C4.37,7.41 4.73,6.23 5.36,5.38C6.17,4.25 7.51,3.68 9.33,3.68C10.79,3.68 11.92,4.09 12.73,4.9C13.5,5.7 13.9,6.8 13.9,8.21C13.9,9.27 13.54,10.24 12.81,11.17L12.12,11.94C9.61,14.16 8.07,15.82 7.51,16.95C6.98,18.01 6.74,19.3 6.74,20.8L6.74,21.76C6.74,22.16 7.07,22.49 7.47,22.49L10.34,22.49C10.74,22.49 11.07,22.16 11.07,21.76L11.07,20.8C11.07,19.79 11.27,18.9 11.72,18.09Z "
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 5",
    fillRule: "evenodd",
    style: {
      fill: "#FFFFFF"
    },
    transform: "translate(27.73790625 40.87384151785714)  rotate(0 2.1428571428571415 2.142857142857135)",
    opacity: 1,
    d: "M4.29,2.68L4.29,1.61C4.29,0.72 3.57,0 2.68,0L1.61,0C0.72,0 0,0.72 0,1.61L0,2.68C0,3.57 0.72,4.29 1.61,4.29L2.68,4.29C3.57,4.29 4.29,3.57 4.29,2.68Z "
  })), /*#__PURE__*/React.createElement("path", {
    id: "\\u77E9\\u5F62",
    fillRule: "evenodd",
    style: {
      fill: "#E5E3EA"
    },
    transform: "translate(0 267)  rotate(0 219 0.5)",
    opacity: 1,
    d: "M0,1L438,1L438,0L0,0L0,1Z "
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoPage);
export default __webpack_public_path__ + "static/media/no_page.5ca5f77f.svg";
export { ForwardRef as ReactComponent };